"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var _dispatcher = _interopRequireDefault(require("dispatcher/dispatcher"));

var _ActionNamespaces = _interopRequireDefault(require("crm_data/actions/ActionNamespaces"));

var _ActionTypes = _interopRequireDefault(require("crm_data/actions/ActionTypes"));

var _KeyStore = require("crm_data/store/KeyStore");

var LINKED_IN_NAVIGATOR = _ActionNamespaces.default.LINKED_IN_NAVIGATOR;
var NAVIGATE = _ActionTypes.default.NAVIGATE,
    SHOW_LINKED_IN_NAVIGATOR = _ActionTypes.default.SHOW_LINKED_IN_NAVIGATOR,
    HIDE_LINKED_IN_NAVIGATOR = _ActionTypes.default.HIDE_LINKED_IN_NAVIGATOR,
    MINIMIZE_LINKED_IN_NAVIGATOR = _ActionTypes.default.MINIMIZE_LINKED_IN_NAVIGATOR,
    MAXIMIZE_LINKED_IN_NAVIGATOR = _ActionTypes.default.MAXIMIZE_LINKED_IN_NAVIGATOR,
    SHOW_COMMUNICATOR = _ActionTypes.default.SHOW_COMMUNICATOR;

var _default = (0, _KeyStore.defineKeyStore)({
  namespace: LINKED_IN_NAVIGATOR,
  getInitialState: function getInitialState() {
    return (0, _immutable.Map)({
      isSelected: false,
      isMinimized: false
    });
  },
  idIsValid: function idIsValid(id) {
    return typeof id === 'string';
  }
}).defineResponseTo(SHOW_LINKED_IN_NAVIGATOR, function (state) {
  return state.merge({
    isSelected: true,
    isMinimized: false
  });
}).defineResponseTo([HIDE_LINKED_IN_NAVIGATOR, SHOW_COMMUNICATOR, NAVIGATE], function (state) {
  return state.set('isSelected', false);
}).defineResponseTo(MINIMIZE_LINKED_IN_NAVIGATOR, function (state) {
  return state.set('isMinimized', true);
}).defineResponseTo(MAXIMIZE_LINKED_IN_NAVIGATOR, function (state) {
  return state.set('isMinimized', false);
}).register(_dispatcher.default);

exports.default = _default;
module.exports = exports.default;